export const LOAD_SAT_DETAILS = "LOAD_SAT_DETAILS";
export const LOAD_SAT_DETAILS_SUCCESS = "LOAD_SAT_DETAILS_SUCCESS";
export const LOAD_SAT_DETAILS_ERROR = "LOAD_SAT_DETAILS_ERROR";
